<div class="parametre-donnees-shell-inner parametre-donnees-shell-inner--full">
  <router-outlet></router-outlet>
</div>
